<div class="body">
  <div class="container ">
    <div class="row title-box mt-3">
      <div class="col-12 col-sm-12">
        <h3 class="txtbienvenida">Administración de <span class="txtbienvenida-2">parametrizacion tipo persona
        </span></h3>
      </div>
    </div>
    <div class="row justify-content-md-center">
      <div class="col-12 col-sm-12 mt-3">
        <p class="title-box">*Desde aqui puedes administrar los parametros del tipo persona de un microempresario y definir las
        solicitudes que quieres atender en la plataforma</p>
      </div>
    </div>
    <div class=" justify-content-md-center">
      <form [formGroup]="filtrosForm" class="custom-form row" (ngSubmit)="onSubmit()">
        <div class="col-12 col-sm-6 mt-4">
          <div class="mb-3 required form-label" [ngClass]="{'is-invalid':validateForm('tipoPersona')}">
            <label for="tipoPersona" class="form-label">Tipo de Persona</label>
            <select class="form-control selectpicker" data-size="5" formControlName="tipoPersona"
              [ngClass]="{'is-invalid':validateForm('tipoPersona')}" multiple data-live-search="true" #select_tipoPersona
              data-width="100%" title="Selecione una opción">
              @for (tipo of listaTipos; track tipo) {
                <option [value]="tipo.idTipoPersonaJuridica">
                  {{tipo.nombre}}
                </option>
              }
            </select>
            <div class="invalid-feedback">
              Campo obligatorio
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-4 align-self-center container-btn g-1">
          <button type="submit" [disabled]="!filtrosForm.valid" id="btn-consular" (click)="onSubmit()"
            class="btn btn-primary hvr-shrink">
            Guardar parámetro
          </button>
        </div>
      </form>
    </div>
    <div class="row justify-content-md-center g-1">
      <div class="col-12 col-sm-4 container-btn mt-2">
        <button class="btn btn-primary hvr-shrink" style="width: 180px;" (click)="goHome()">Volver</button>
      </div>
    </div>
  </div>
  <div class="footer-body"></div>
</div>
<ngx-spinner type="ball-scale-multiple"></ngx-spinner>
